// removed by extract-text-webpack-plugin
module.exports = {"caption":"Slot_caption--1vyHw","base":"Slot_base--1dk8f","base__own":"Slot_base__own--32jL8","baseOwn":"Slot_base__own--32jL8","clickArea":"Slot_clickArea--1MEIE","captionInner":"Slot_captionInner--2oDjg","icon":"Slot_icon--GC_n3"};


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Slot/Slot.scss
// module id = 557
// module chunks = 11 13